import { useDrawer } from '@dashhudson/dashing-ui/drawer';
import { computed, ref } from 'vue';

import { useMediaPopupStore } from '@/stores/media-popup';

const propsListIndex = ref();
const context = ref({});

export function useMediaDrawer() {
  const mediaPopupStore = useMediaPopupStore();
  const { launchDrawer } = useDrawer();

  const propsList = computed(() =>
    (mediaPopupStore.contextList ?? [])?.map((contextListItem) => {
      const id = contextListItem.id || contextListItem.sourceId;
      const source = contextListItem.source;

      const patchJson = { ...context.value.patchJson, media_id: id };
      if (contextListItem[source]?.timestamp) {
        patchJson.timestamp = contextListItem[source].timestamp;
      }

      return {
        id,
        patchJson,

        brandLabel: context.value.brandLabel,
        brandId: context.value.brandId,
        source: context.value.source,
      };
    }),
  );

  async function openMedia({ id, brandId, brandLabel, source, patchJson: incomingPatchJson }) {
    const patchJson = { ...incomingPatchJson, media_id: id };

    context.value = { brandId, brandLabel, source, patchJson };

    void launchDrawer({
      name: 'media',
      props: {
        id,
        brandId,
        brandLabel,
        source,
        patchJson,
      },
      propsList: propsList.value,
    });
  }

  function updatePropsListIndex(media) {
    if (!media || !propsList.value) {
      propsListIndex.value = null;
      return;
    }

    propsListIndex.value = propsList.value.findIndex((item) => {
      if (item.id) {
        return item.id === media.id || item.id === media.postSourceId;
      }
      return item.sourceId === media.postSourceId;
    });
  }

  const hasPreviousMedia = computed(() => {
    if (propsList.value?.length > 0) {
      return propsListIndex.value > 0;
    }
    return false;
  });

  const hasNextMedia = computed(() => {
    if (propsList.value?.length > 0) {
      return propsListIndex.value < propsList.value.length - 1;
    }
    return false;
  });

  function loadPreviousMedia() {
    if (!hasPreviousMedia.value) {
      return null;
    }

    propsListIndex.value -= 1;
    const previousProps = propsList.value[propsListIndex.value];

    void openMedia(previousProps);

    return previousProps;
  }

  function loadNextMedia() {
    if (!hasNextMedia.value) {
      return null;
    }

    propsListIndex.value += 1;
    const nextProps = propsList.value[propsListIndex.value];

    void openMedia(nextProps);

    return nextProps;
  }

  return {
    openMedia,
    hasPreviousMedia,
    hasNextMedia,
    loadPreviousMedia,
    loadNextMedia,
    updatePropsListIndex,
  };
}
